module.exports = __webpack_public_path__ + "static/media/cedg.bacf5279.jpg";